import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatUrl } from 'ThreeTerminal_base/publicMethod';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import Ad from '@ifeng-fe/ui_pc_ad';
import 'intersection-observer';
import { formatWebpUrl } from '../../../../utils/formatWebp';

const SsrIntersectionObserver = function SsrIntersectionObserver() {};

SsrIntersectionObserver.prototype = {
    observe: function observe() {},
    unobserve: function unobserve() {},
};

const RealIntersectionObserver =
    typeof IntersectionObserver !== 'undefined' ? IntersectionObserver : SsrIntersectionObserver;

class Text extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
        isBig: PropTypes.bool,
        imagesInContent: PropTypes.array,
        thumbnails: PropTypes.object,
        handleGalleryOpen: PropTypes.func,
        pageInfo: PropTypes.object,
        pageType: PropTypes.string,
        base62Id: PropTypes.string,
        wxLaunch: PropTypes.object,
        isHitBlack: PropTypes.bool,
        textListAd: PropTypes.object,
        index: PropTypes.number,
    };

    ref = React.createRef();

    isAddCallClient = false;

    getImageSize = async (url) => {
        if (!url) {
            return {};
        }

        return new Promise((resolve, reject) => {
            const myImage = document.createElement('img');

            myImage.style.maxWidth = '100%';
            myImage.style.visibility = 'hidden';
            myImage.style.position = 'absolute';
            myImage.style.left = '-1000px';
            myImage.src = url;
            document.body.appendChild(myImage);

            myImage.onload = () => {
                resolve({
                    width: myImage.offsetWidth,
                    height: myImage.offsetHeight,
                });
                myImage.parentElement.removeChild(myImage);
            };
            myImage.onerror = () => {
                reject({});
                myImage.parentElement.removeChild(myImage);
            };
        });
    };

    componentDidMount() {
        const observer = new RealIntersectionObserver((changes) => {
            changes
                .filter((item) => item.isIntersecting > 0)
                .forEach((change) => {
                    const container = change.target;

                    container.src = formatWebpUrl(container.getAttribute('data-lazyload'));

                    container.style.paddingTop = 0;
                    container.style.backgroundColor = 'rgba(255,255,255,0)';
                    container.style.backgroundImage = '';

                    if (container.classList && container.classList.remove) {
                        container.onload = () => {
                            container.classList.remove('empty_bg');
                        };
                    }

                    observer.unobserve(container);
                });
        });

        Array.from(this.ref.current.querySelectorAll('[data-lazyload]')).forEach((item) => {
            observer.observe(item);
        });

        Array.from(this.ref.current.querySelectorAll('a[ifengapp-data]')).forEach((item) => {
            const shopLink =
                (item &&
                    item.getAttribute('ifengapp-data') &&
                    decodeURIComponent(item.getAttribute('ifengapp-data')) &&
                    JSON.parse(decodeURIComponent(item.getAttribute('ifengapp-data'))) &&
                    JSON.parse(decodeURIComponent(item.getAttribute('ifengapp-data'))).webUrl) ||
                '';

            if (shopLink) {
                item.setAttribute('href', shopLink);
            }
        });
        // 图片内添加引导
        this.imageAddCallClient();
    }

    imageAddCallClient = async () => {
        const { pageInfo, base62Id } = this.props;
        const allImageList = Array.from(this.ref.current.querySelectorAll('img')).slice(0);
        let imageFlagNum = -1;

        for (let i = 0; i < allImageList.length; i++) {
            const imageItem = allImageList[i];
            const imgParent = imageItem.parentElement;
            const imageIndex = i;
            let imgSrc = '';

            if (imageItem.getAttribute('data-lazyload')) {
                imgSrc = formatWebpUrl(imageItem.getAttribute('data-lazyload'));
            } else if (imageItem.getAttribute('src')) {
                imgSrc = imageItem.getAttribute('src');
            }

            if (this.isAddCallClient) {
                imgSrc = '';
            }

            if (imgParent.tagName !== 'A' && imageFlagNum !== imageIndex) {
                this.imageNoClick(imageItem);
            }
        }
    };

    imageNoClick = (imageItem) => {
        const { handleGalleryOpen } = this.props;

        imageItem.onclick = (e) => {
            const url = e.currentTarget.getAttribute('data-lazyload') || e.currentTarget.getAttribute('src');
            const index = this.getCurrentIndex(url) || 0;

            handleGalleryOpen(index);
        };
    };

    launchAppHandle = (divOutDom, pageInfo, base62Id, client) => {
        const { wxLaunch } = this.props;
        const wxLaunchSwitch = wxLaunch.wxLaunchSwitch;
        const wxLaunchType = wxLaunch.wxLaunchType;
        const schemeLink =
            wxLaunch.wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: 'doc',
                      pid: pageInfo._id || pageInfo.base62Id,
                  })
                : getSchemeLink({
                      docType: 'doc',
                      pid: pageInfo._id || pageInfo.base62Id,
                      kind: 'share52210',
                  });
        const divWxDom = document.createElement('div');

        divWxDom.style.left = '0';
        divWxDom.style.top = '0';
        divWxDom.style.width = '100%';
        divWxDom.style.height = '100%';
        divOutDom.appendChild(divWxDom);

        ReactDOM.render(
            !pageInfo.isVideoShare && wxLaunchSwitch && (
                <WxLaunchApp
                    launchType={wxLaunchType}
                    parentPosition={'absolute'}
                    launchAppClick={this.clickHandle.bind(this, pageInfo, base62Id, client, true, false, false)}
                    schemeLink={schemeLink}
                    launchAppFail={this.clickHandle.bind(this, pageInfo, base62Id, client, false, true, true)}
                />
            ),
            divWxDom,
        );
    };

    clickHandle = (pageInfo, base62Id, client, isSendCount = true, isJumpQQlink = false, isCallAppWx = true) => {
        const doc_type = 'doc';
        const aid = pageInfo._id || pageInfo.base62Id || '';
        const downloads = pageInfo.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1350561044933',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7495',
              };

        if (isSendCount) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'seepic',
                    other: {
                        ref: `ucms_${base62Id}`,
                        kind: 'article',
                    },
                },
            ]);
        }

        if (isJumpQQlink) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'seepic',
                    other: {
                        ref: `ucms_${base62Id}`,
                        kind: 'article',
                        tag: 't9',
                    },
                },
            ]);
        }

        if (isCallAppWx) {
            callApp({
                client,
                docType: doc_type,
                pid: aid,
                kind: 'share52210',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    getCurrentIndex = (url) => {
        const { imagesInContent } = this.props;

        url = formatUrl(url);

        for (let i = 0; i < imagesInContent.length; i++) {
            if (imagesInContent[i].url.includes(url)) {
                return i;
            }
        }
    };

    render() {
        const { isBig, content, imagesInContent, pageType, thumbnails, isHitBlack, textListAd, index } = this.props;

        const lazyHtml = content ? content : '';

        return (
            <>
                <div
                    className={`${styles.text}  ${pageType === 'short' ? styles.shortText : ''} ${
                        index === 0 ? styles.firstText : ''
                    }`}
                    dangerouslySetInnerHTML={{ __html: lazyHtml }}
                    ref={this.ref}
                />
                {!isHitBlack && textListAd && <Ad content={textListAd} />}
            </>
        );
    }
}

export default Text;
